module.exports = __webpack_public_path__ + "static/media/designed-for-everyone.e5c67be6.jpg";